import { render } from "./SurveyRespondentsTable.vue?vue&type=template&id=2a8b8a5a"
import script from "./SurveyRespondentsTable.vue?vue&type=script&lang=js"
export * from "./SurveyRespondentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__